import { createContext, useContext } from 'react';
import type { Participante } from '../graph/types';

export interface UsuarioActual {
  id: string;
  nombre: string;
}

/** Lo que un pin de comentario necesita del editor. */
export interface ComentariosCtx {
  usuario: UsuarioActual;
  participantes: Participante[];
  /** Pin con el hilo abierto (uno a la vez). */
  abiertoId: string | null;
  abrir: (id: string | null) => void;
  agregarMensaje: (id: string, texto: string) => void;
  alternarResuelto: (id: string) => void;
  borrar: (id: string) => void;
  ocultarResueltos: boolean;
}

export const ComentariosContext = createContext<ComentariosCtx>({
  usuario: { id: '', nombre: '' },
  participantes: [],
  abiertoId: null,
  abrir: () => {},
  agregarMensaje: () => {},
  alternarResuelto: () => {},
  borrar: () => {},
  ocultarResueltos: false,
});

export const useComentarios = (): ComentariosCtx => useContext(ComentariosContext);

// "Hace cuánto" y la inicial del avatar se mudaron a `utils/comentariosUi` cuando
// los comentarios del lanzamiento adoptaron esta misma cara
// (ADR-2026-09-15-los-comentarios-del-lanzamiento-se-ven-como-los-de-flujos): son
// el mismo texto en las dos pantallas y ahora hay una sola implementación. Se
// siguen re-exportando desde acá para no tocar a quien ya los importaba.
export { cuando, inicialDe } from '../../../utils/comentariosUi';
